export default __webpack_public_path__ + "static/plexus-full-width-3-f6b6f07b1f4d19c7df5cfb0b3a2a2836.avif";